import type { IntegratorFeatureServices } from '../feature-hub/service-dependencies';
import { NotificationTypeV1 } from '@oneaudi/audi-notification-display-service';
import { getPreviewToken } from '../feature-hub/page-content';
import { parseJwtContent } from './jwt';

export function displayPreviewTenant(
  notificationService: IntegratorFeatureServices['notification-display-service'],
  head: Element,
): void {
  const previewToken = getPreviewToken(head);

  if (previewToken) {
    const claims = parseJwtContent(previewToken);
    const expiryTime = new Date(claims.exp * 1000);
    const previewTenant = claims['mandant-id'];

    notificationService.createNotification(
      NotificationTypeV1.POPUP_SUCCESS,
      'preview-tenant',
      `Tenant: ${previewTenant}\nActive until: ${expiryTime.getHours()}:${expiryTime.getMinutes().toString(10).padStart(2, '0')}`,
      {
        title: 'Preview tenant activated',
      },
    );
  }
}
